import { createContext } from "react";

/**
 * Where a chat figure is drawn. `floating` figures fill the floating window
 * instead of taking their fence height, and drop the pop-out action (they
 * already are popped out).
 */
export type FigureHost = "inline" | "floating";

export const FigureHostContext = createContext<FigureHost>("inline");
